module.exports = __webpack_public_path__ + "static/img/til180.79dedfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til180.png
// module id = bID/
// module chunks = 1